import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ApplicationInfoSelectedForScientificCommittee from "../../Pages/Manager/SetScientificCommittee/ApplicationInfoSelectedForScientificCommittee";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import TextAreaAHSF from "../../Components/TextAreaAHSF";
import ButtonAHSF from "../../Components/ButtonAHSF";
import Swal from "sweetalert2";
import {
  GetAllSubTaskForScientificBodyAssigningBysubtask,
  RecommendationScientificBodyButtons,
} from "../../Redux/Reducers/Manager/ScientificCommittee";
import { useNavigate, useParams } from "react-router-dom";
import { GetOneflowActionScientificCommitteeBySubTaskId } from "../../Redux/Reducers/Manager/FlowActionScientificCommittee";
import { SetArrayDataCheckBoks } from "../../Redux/Reducers/Shared/CheckBox";
import { GetSpecificRowSubTask } from "../../Redux/Reducers/Manager/SubTask";

const ScientificCommitteeAction = (props) => {
  const navigator = useNavigate();
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.languageReducer.Language);

  const { subTaskId } = useParams();

  const [note, setNote] = useState("");

  const arrayDataCheckBoks = useSelector(
    (state) => state.arrayDataCheckBoks?.arrayDataCheckBoks["tasksList"]
  );
  const GetOneflowActionScientificCommitteeBySubTask = useSelector(
    (state) =>
      state.FlowActionScientificCommittee?.FlowActionScientificCommittee
  );
  const GetAllSubTaskForScientific = useSelector(
    (state) => state.ScientificCommittee?.GetAllSubTaskForScientific
  );
  const SubTask = useSelector((state) => state.SubTask?.SubTaskById);
  console.log(SubTask, "SubTask");

  const validation = () => {
    const validationMassage = [];
    console.log(note, "notenotenotenote");

    if (!note)
      validationMassage.push(
        lang == "en" ? "Please write a note" : "الرجاء كتابة ملاحظة"
      );
    if (
      !arrayDataCheckBoks ||
      arrayDataCheckBoks.length === 0
    ) {
      validationMassage.push(
        lang == "en"
          ? "Please Select A Application"
          : "يجب اختيار طلب واحد على الاقل"
      );
    }

    if (validationMassage.length > 0) {
      Swal.fire({
        icon: "warning",
        title:
          lang == "en"
            ? "Please fill in the following fields"
            : "الرجاء تعبئة الحقول التالية",
        html: `
            <div style="text-align: ${
              lang == "en" ? "left" : "right"
            }; direction: ${lang == "en" ? "ltr" : "rtl"}; font-size: 16px;">
              <ul style="list-style-type: none; padding: 0;">
                ${validationMassage
                  .map(
                    (field) =>
                      `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
                  )
                  .join("")}
              </ul>
            </div>
          `,
        confirmButtonText: lang == "en" ? "Ok" : "حسناً",
        customClass: {
          popup: "swal2-border-radius",
        },
      });
      return false;
    }

    return true;
  };
console.log(arrayDataCheckBoks,"dsddsdsssssssa");

  const validationAgree = () => {
    const validationMassage = [];

    if (!arrayDataCheckBoks || arrayDataCheckBoks.length === 0) {
      validationMassage.push(
        lang === "en"
          ? "At least one application must be selected."
          : "يجب اختيار طلب واحد على الاقل"
      );
    }

    if (validationMassage.length > 0) {
      Swal.fire({
        icon: "warning",
        title:
          lang === "en"
            ? "Please fill in the following fields"
            : "الرجاء تعبئة الحقول التالية",
        html: `
        <div style="text-align:${lang === "en" ? "left" : "right"}; direction:${
          lang === "en" ? "ltr" : "rtl"
        }">
          <ul style="list-style:none;padding:0">
            ${validationMassage
              .map(
                (field) =>
                  `<li style="margin-bottom:8px;">🔸 <strong>${field}</strong></li>`
              )
              .join("")}
          </ul>
        </div>
      `,
        confirmButtonText: lang === "en" ? "Ok" : "حسناً",
      });

      return false;
    }

    return true;
  };

  useEffect(() => {
    dispatch(
      GetOneflowActionScientificCommitteeBySubTaskId({ subTaskId: subTaskId })
    );
  }, [subTaskId]);

  useEffect(() => {
    dispatch(
      GetSpecificRowSubTask({
        subTaskId: subTaskId,
      })
    );
  }, [subTaskId]);
  // console.log(arrayDataCheckBoks.map((ele)=>ele.subTaskId),"sssssssssssssdwdwdwd");

  return (
    <>
      <ApplicationInfoSelectedForScientificCommittee />

      <SharedDiv
        showTitle={true}
        titleNameEN="Procedures"
        titleNameAR="الإجراءات"
        lang={lang}
        titleName="الإجراءات"
        child={[
          <div className="form-grid">
            <TextAreaAHSF
              fieldsName="ScientificCommitteeNotes"
              show={true}
              lang={lang}
              defaultValue={
                GetOneflowActionScientificCommitteeBySubTask?.additionalNote
              }
              disabled={
                GetOneflowActionScientificCommitteeBySubTask?.additionalNote
                  ? true
                  : false
              }
              onChange={(e) => {
                setNote(e.target.value);
              }}
            />
          </div>,
        ]}
      />
      <></>
      {SubTask?.taskStatusId !== "8c4ee6bd-442b-4258-8c68-d25e881b3e2d" && (
        <div className="containerButtonMAin">
          <ButtonAHSF
            type={"submitter"}
            fieldsName="RecomindationAgree"
            lang={lang}
            text={"اخذ اجراء"}
            onClick={async () => {
              if (!validationAgree()) return;

              try {
                const result = await dispatch(
                  RecommendationScientificBodyButtons({
                    SubTaskId: arrayDataCheckBoks.map((ele) => ele.subTaskId),
                    note:
                      note == null || note === ""
                        ? GetOneflowActionScientificCommitteeBySubTask?.additionalNote
                        : note,
                    actionIdFromTaskStatus:
                      "12dee5f5-1e37-4f83-beac-910e2e0b881c",
                  })
                );

                if (result.payload?.success === true) {
                  Swal.fire({
                    icon: "success",
                    title:
                      lang === "en"
                        ? "Successful acceptance"
                        : "تم القبول بنجاح",
                    text:
                      lang === "en"
                        ? "Recommended for successful admission"
                        : "تم توصية بالقبول بنجاح",
                    confirmButtonText: lang === "en" ? "Ok" : "حسناً",
                  });

                  navigator(
                    "/ResearchersAward/manager/scientific/ScientificCommitteeRequsetTable/"
                  );
                }

                dispatch(SetArrayDataCheckBoks());
              } catch (error) {
                Swal.fire({
                  icon: "error",
                  title: lang === "en" ? "An error occurred" : "حدث خطأ",
                  text:
                    lang === "en"
                      ? "An error occurred while performing the procedure. Please try again later."
                      : "حدث خطأ أثناء تنفيذ الإجراء. حاول مرة أخرى لاحقًا",
                  confirmButtonText: lang === "en" ? "Ok" : "حسناً",
                });
              }
            }}
            disabled={false}
            title={"اخذ اجراء"}
            show={true}
          />

          <ButtonAHSF
            type={"submitter"}
            fieldsName="RecomindationDisAgree"
            lang={lang}
            text={"اخذ اجراء"}
            onClick={async () => {
              if (validation()) {
                try {
                  const result = await dispatch(
                    RecommendationScientificBodyButtons({
                      SubTaskId: arrayDataCheckBoks.map((ele) => ele.subTaskId),
                      note:
                        note == null || note == ""
                          ? GetOneflowActionScientificCommitteeBySubTask?.additionalNote
                          : note,
                      actionIdFromTaskStatus:
                        "38a971cd-34a6-4bed-a74a-1309d54928fb",
                    })
                  );

                  if (result.payload?.success === true) {
                    Swal.fire({
                      icon: "success",
                      title:
                        lang == "en"
                          ? "Successfully rejected"
                          : "تم الرفض بنجاح",
                      text:
                        lang == "en"
                          ? "Rejection was recommended for applications that were successfully selected"
                          : "تم التوصية بالرفض على الطلبات المختارة بنجاح",
                      confirmButtonText: lang == "en" ? "Ok" : "حسناً",
                    });

                    navigator(
                      "/ResearchersAward/manager/scientific/ScientificCommitteeRequsetTable/"
                    );
                    dispatch(SetArrayDataCheckBoks());
                  }
                } catch (error) {
                  Swal.fire({
                    icon: "error",
                    title: lang == "en" ? "An error occurred" : "حدث خطأ",
                    text:
                      lang == "en"
                        ? "An error occurred while sending recommendations. Please try again later"
                        : "حدث خطأ أثناء إرسال التوصيات. حاول مرة أخرى لاحقًا",
                    confirmButtonText: lang == "en" ? "Ok" : "حسناً",
                  });
                  console.error("Error dispatching completion action:", error);
                }
              }
            }}
            disabled={false}
            title={"اخذ اجراء"}
            show={true}
          />
        </div>
      )}
    </>
  );
};

export default ScientificCommitteeAction;
